import React, { useEffect } from 'react';

// Component-specific styles. This approach keeps styles encapsulated
// with the component in a single file.
const styles = `
  body {
    /* Set a default background color for the page */
    background-color: #010A1A;
    font-family: 'Inter', sans-serif;
  }

  .text-gradient {
    /* Create a linear gradient for the background */
    background-image: linear-gradient(45deg, #3498db, #9b59b6);
    
    /* Clip the background to the text */
    -webkit-background-clip: text; /* For Safari/Chrome */
    background-clip: text;
    
    /* Make the text color transparent to show the gradient background */
    color: transparent;
  }
`;

const ConstructionPage = () => {
    // This effect runs once when the component mounts to inject the styles.
    useEffect(() => {
        // Create a <style> element
        const styleSheet = document.createElement("style");
        styleSheet.innerText = styles;
        
        // Append it to the <head> of the document
        document.head.appendChild(styleSheet);

        // Cleanup function: remove the stylesheet when the component unmounts
        return () => {
            if (document.head.contains(styleSheet)) {
                document.head.removeChild(styleSheet);
            }
        };
    }, []); // Empty dependency array means this effect runs only once

    return (
        <div className="bg-black text-gray-200">
            <main className="min-h-screen flex flex-col items-center justify-center p-6">
                <div className="text-center max-w-4xl mx-auto">
                    {/* The h1 now has the .text-gradient class for the gradient effect */}
                    <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-white text-gradient">
                        Work in progress.
                    </h1>
                    <p className="mt-6 text-lg md:text-xl leading-8 text-gray-400 max-w-2xl mx-auto">
                        We’re crafting something truly special. Our next product is being meticulously designed to deliver an unparalleled experience. Perfection takes time, but it will be worth the wait.
                    </p>
                </div>
            </main>
        </div>
    );
};

export default ConstructionPage;
